export default __webpack_public_path__ + "static/boat-loan-afb75de6b977eb707e8225f773a1832f.webp";